import { ReactElement, MouseEventHandler } from 'react'
import { Route as RouteIcon } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

interface Props {
  active?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

/** Toggles tracing a load back to its previous loads in the scene. */
const LoadTraceIconButton = ({ active = false, onClick }: Props): ReactElement => {
  return (
    <Tooltip title={active ? 'Lastherkunft ausblenden' : 'Lastherkunft anzeigen'}>
      <IconButton
        size="small"
        color={active ? 'primary' : 'default'}
        onClick={onClick}
        data-cy="load-trace-button"
      >
        <RouteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default LoadTraceIconButton
